/**
 * @group Constants

@summary
<blockquote>Available reporting transport types</blockquote>

@example
```typescript
const transport = REPORTING_TRANSPORTS.POSTHOG;
// or
const transport = REPORTING_TRANSPORTS.CONSOLE;
```
 * @internal
 */
export const REPORTING_TRANSPORTS = {
  POSTHOG: 'posthog',
  CONSOLE: 'console',
} as const;